"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parsePanelModerationQueue = exports.PanelModerationQueueSchema = void 0;
const zod_1 = require("zod");
const lingo2_models_1 = require("lingo2-models");
const panel_account_1 = require("./panel-account");
const panel_content_1 = require("./panel-content");
const panel_meeting_1 = require("./panel-meeting");
const panel_collection_1 = require("./panel-collection");
const panel_user_service_1 = require("./panel-user-service");
const entity_changes_1 = require("./entity-changes");
exports.PanelModerationQueueSchema = zod_1.z.object({
  id: zod_1.z.string(),
  account_id: zod_1.z.string().optional(),
  content_id: zod_1.z.string().optional(),
  meeting_id: zod_1.z.string().optional(),
  collection_id: zod_1.z.string().optional(),
  user_service_id: zod_1.z.string().optional(),
  moderator_id: zod_1.z.string().optional(),
  type: zod_1.z.nativeEnum(lingo2_models_1.ModerationQueueTypeEnum).optional(),
  status: zod_1.z.nativeEnum(lingo2_models_1.ModerationQueueStatusEnum).optional(),
  changes: entity_changes_1.ModerationQueueChangesSchema.optional(),
  resolution: zod_1.z.nativeEnum(lingo2_models_1.ModerationStatusEnum).optional(),
  reason: zod_1.z.string().optional(),
  created_at: zod_1.z.string().datetime().or(zod_1.z.date()).optional(),
  updated_at: zod_1.z.string().datetime().or(zod_1.z.date()).optional(),
  deleted_at: zod_1.z.string().datetime().or(zod_1.z.date()).optional(),
  account: panel_account_1.PanelAccountSchema.partial(),
  moderator: panel_account_1.PanelAccountSchema.partial(),
  content: panel_content_1.PanelContentSchema.partial(),
  meeting: panel_meeting_1.PanelMeetingSchema.partial(),
  collection: panel_collection_1.PanelCollectionSchema.partial(),
  user_service: panel_user_service_1.PanelUserServiceSchema.partial()
});
const parsePanelModerationQueue = values => exports.PanelModerationQueueSchema.parse(values);
exports.parsePanelModerationQueue = parsePanelModerationQueue;
